import { TENANT_REGION, REGIONS } from '../constants'
import { ProviderType, WorkflowTempLocation } from 'features/connections'

export function calculateRegion({
  tempLocation,
  provider,
  tenantId
}: {
  tempLocation: WorkflowTempLocation
  provider: ProviderType
  tenantId: string
}): string | undefined {
  const defaultRegion = TENANT_REGION[tenantId] || REGIONS.US

  const region = provider === ProviderType.BIGQUERY ? tempLocation?.region || defaultRegion : undefined

  return region
}
